import Logo from "../assets/logo.png";
import {
    Container,
    Nav,
    Navbar,
} from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";

function Header() {

    return (
        <div className="App" style={{ paddingHorizontal: 25 }}>
            <header className="App-header">
                <div
                    style={{
                        height: 73,
                        width: "100%",
                        backgroundColor: "#202020",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <img src={Logo} alt="" style={{ height: 73, width: 301 }} />
                </div>
                <Navbar expand="lg" className="bg-body-tertiary">
                    <Container fluid>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav
                                className="me-auto my-2 mx-5  my-lg-0"
                                style={{
                                    maxHeight: "100px",
                                    width: "100%",
                                    justifyContent: "space-between",
                                }}
                                navbarScroll>
                                <NavLink to="/home" className="nav-link" activeclassname="active">
                                    Home
                                </NavLink>
                                <NavLink to="/courses" className="nav-link" activeclassname="active">
                                    Courses
                                </NavLink>
                                <NavLink to="/resources" className="nav-link" activeclassname="active">
                                    Resources
                                </NavLink>
                                <NavLink to="/alg" className="nav-link" activeclassname="active">
                                    ALG
                                </NavLink>
                                <NavLink to="/co-ordinators" className="nav-link" activeclassname="active">
                                    Co-Ordinators
                                </NavLink>
                                <NavLink to="/prem-schedules" className="nav-link" activeclassname="active">
                                Perm Schedules
                                </NavLink>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>
        </div>
    );
}

export default Header;
